import React, { FunctionComponent } from 'react';

import { Tooltip, OverlayTrigger } from 'react-bootstrap';

import { Role } from 'admin/roles/Roles';
import { User } from 'admin/users/Users';

import 'common/avatar/Avatar.scss';

interface Props {
    type: AvatarType;
    object?: Partial<User> | Partial<Role>;
}

export enum AvatarType {
    User = 0,
    Role = 1,
    Queue = 2,
    Location = 3,
}

export const Avatar: FunctionComponent<Props> = ({ type, object }) => {
    /* eslint-disable no-nested-ternary */
    return (
        <div className="r4e-avatar">
            {type === AvatarType.User ? (
                <>
                    {object && (object as User).image ? (
                        <div className="avatar-img" style={{ backgroundImage: `url(${(object as User).image})` }} />
                    ) : object && !(object as User).image ? (
                        <div className="avatar-initials" style={{ backgroundColor: (object as User).color }}>
                            <OverlayTrigger
                                trigger={['hover', 'focus']}
                                overlay={<Tooltip id="tooltip">{(object as User).tooltip}</Tooltip>}
                            >
                                <span>{(object as User).initials}</span>
                            </OverlayTrigger>
                        </div>
                    ) : null}
                </>
            ) : type === AvatarType.Queue ? (
                <div className="avatar-queue" style={{ backgroundColor: (object as User).color }}>
                    <OverlayTrigger
                        trigger={['hover', 'focus']}
                        overlay={<Tooltip id="tooltip">{(object as User).tooltip}</Tooltip>}
                    >
                        <span className="avatar-queue-name">{(object as User).initials}</span>
                    </OverlayTrigger>
                </div>
            ) : type === AvatarType.Role ? (
                <div className="avatar-role">
                    <i className="icon-id-badge" />
                </div>
            ) : type === AvatarType.Location ? (
                <div className="avatar-location">
                    <div className="avatar-initials" style={{ backgroundColor: (object as User).color }}>
                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            overlay={<Tooltip id="tooltip">{(object as User).tooltip}</Tooltip>}
                        >
                            <i className="icon-map-marker-alt" />
                        </OverlayTrigger>
                    </div>
                </div>
            ) : null}
        </div>
    );
};
